import React from "react";

/**
 * ============================================================================
 * ############## NavButton：桌面端导航按钮 ####################################
 * ============================================================================
 *
 * 【作用】桌面端导航条上的单个页面链接按钮（首页、研究、论文等）。仅用于展开模式（≥lg）；
 * 缩略模式（<lg）下由 SiteNavbar 的下拉菜单直接渲染链接，不使用本组件。
 *
 * 【间距说明】每个标签之间的间隔不在此写死，而是由父级 SiteNavbar 的 “NAV CENTER” 容器
 * 通过响应式 gap 控制：lg 时较紧、xl/2xl 随视口拉长。详见 SiteNavbar.tsx 顶部【如何修改】1)。
 *
 * 【如何修改】
 * - 单个按钮左右留白：改下方 px-2（如 px-3 更宽、px-1 更紧），仅影响按钮自身，不影响标签间距。
 * - 字号与字间距：text-sm、tracking-widest；中文过散可改为 tracking-wide 或 tracking-normal。
 * - 激活态下划线：见下方 span 的 h-0.5、from-cyan-400 to-purple-500。
 */
export interface NavButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  themeMode: "light" | "dark";
}

const NavButton: React.FC<NavButtonProps> = ({ label, isActive, onClick, themeMode }) => {
  const isLight = themeMode === "light";

  return (
    <button
      onClick={onClick}
      className={`relative px-2 py-1.5 text-sm font-medium tracking-widest uppercase transition-all duration-300 ${
        isActive
          ? (isLight ? "text-gray-900" : "text-white")
          : (isLight ? "text-gray-600 hover:text-cyan-600" : "text-gray-400 hover:text-cyan-400")
      }`}
    >
      {label}
      {isActive && (
        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-cyan-400 to-purple-500 shadow-[0_0_10px_rgba(6,182,212,0.8)]"></span>
      )}
    </button>
  );
};

export default NavButton;
